import { ScrollTabs } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestTypes/exceptions/scrollTabs/ScrollTabs'
import React, { useMemo, useState } from 'react'

import { Table } from 'core-components/library/list'
import { ITabProps } from 'core-components/library/tabButtons/models/ITab'
import { Crud } from 'core/types/Crud'
import { ThirdPartyLogApplication } from 'onboarding/classes/models/thirdPartyLog'
import { fail } from 'onboarding/classes/services/notification'

import { EMPTY_SOURCE, getColumnsByApplication, getRowsPerPageOptions } from './configs/logList'
import { getReadableTabName } from './helpers/getReadableTabName'
import { TAdditionalApplicationSourceSettings } from './types'

interface IProps {
  applications: ThirdPartyLogApplication[]
  createApplicationLogsCrud: (application: ThirdPartyLogApplication) => Crud
  additionalApplicationSourceSettings?: TAdditionalApplicationSourceSettings
}

export const ThirdPartyLogList = ({
  applications,
  createApplicationLogsCrud,
  additionalApplicationSourceSettings,
}: IProps) => {
  const [chosenApplication, setChosenApplication] = useState<ThirdPartyLogApplication>(
    applications[0]
  )
  const tabs: ITabProps[] = useMemo(() => {
    return applications.map((i) => ({
      id: i,
      content: () => <></>,
      title: () => <span>{getReadableTabName(i)}</span>,
    }))
  }, [applications])

  const sources = useMemo(() => {
    const result: Map<ThirdPartyLogApplication, Crud> = new Map()
    applications.forEach((application) => {
      const source = createApplicationLogsCrud(application)

      if (additionalApplicationSourceSettings) {
        const applySettings = additionalApplicationSourceSettings[application]
        applySettings && applySettings(source)
      }

      result.set(application, source)
    })

    return result
  }, [applications, createApplicationLogsCrud, additionalApplicationSourceSettings])

  const resultSource = useMemo(
    () => (chosenApplication ? sources.get(chosenApplication) || EMPTY_SOURCE : EMPTY_SOURCE),
    [sources, chosenApplication]
  )

  return chosenApplication ? (
    <div>
      <ScrollTabs
        items={tabs}
        value={chosenApplication}
        onChange={(id) => setChosenApplication(id as ThirdPartyLogApplication)}
      />
      <Table
        header
        pagination
        source={resultSource}
        columns={getColumnsByApplication(chosenApplication)}
        rowsPerPageOptions={getRowsPerPageOptions()}
        onDataLoadError={(error) => {
          fail(error.message)
        }}
      />
    </div>
  ) : (
    <div>No logs can be displayed...</div>
  )
}
